define([
	"dojo/_base/declare",
	"csi/resolver",
	"csi/table/Copy",
	"Specification",
	"Specification/BOM/BOMSupplierAttributesMixin"
], function(declare,resolver,Copy,Specification,BOMSupplierAttributesMixin) {

	return declare([Copy, BOMSupplierAttributesMixin], {
		_getCopyName: function(/*Node*/nodeSource, /*String[]*/params) {
			// summary: only append -COPY if no placements
			var	nodeAdmin = resolver.resolveNode(Specification.URL_ADMIN, true);
			return nodeAdmin.Placements.length ? nodeSource.$Name : this.inherited(arguments);
		}
	});
});